var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitBranch = function SvgGitBranch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.234 2.047a3.717 3.717 0 1 1-3.665 4.335 8.75 8.75 0 0 0-8.185 8.184 3.718 3.718 0 1 1-1.218-.003V2.646a.6.6 0 0 1 1.2 0v7.734a9.95 9.95 0 0 1 8.198-5.201 3.72 3.72 0 0 1 3.67-3.132M5.766 15.715l-.007-.001a2.518 2.518 0 1 0 .012 0zM18.234 3.246a2.518 2.518 0 1 0 .001 5.036 2.518 2.518 0 0 0 0-5.036"
  })));
};
export default SvgGitBranch;